import React from 'react';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

type ChatLoaderProps = {
   minHeight?: string;
};

const ChatLoader = ({ minHeight }: ChatLoaderProps) => {
   const [isMounted, setIsMounted] = useState(false);

   useEffect(() => {
      setIsMounted(true); // Start blinking when mounted

      return () => setIsMounted(false); // Stop blinking when unmounted
   }, []);

   return (
      <Box sx={{ minHeight }}>
         <Box
            sx={{
               minWidth: 24,
               maxWidth: 24,
               maxHeight: 24,
               minHeight: 24,
               backgroundColor: '#F0CAC9',
               borderRadius: '100%',
               animation: isMounted ? 'blink 1s infinite alternate' : 'none',
               '@keyframes blink': {
                  '0%': { opacity: 1 },
                  '100%': { opacity: 0.3 },
               },
            }}
         />
      </Box>
   );
};

export default ChatLoader;
